var _desc, _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip565_52647"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Solid/server",
    width: 10,
    height: 10,
    transform: "translate(3.000000 3.000000)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    rx: 8,
    width: 16,
    height: 16,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    x: 0.5,
    y: 0.5,
    rx: 7.5,
    width: 15,
    height: 15,
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip565_52647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5 4.5C4.44 4.5 4 4.94 4 5.5L4 6.5C4 7.05 4.44 7.5 5 7.5L11 7.5C11.55 7.5 12 7.05 12 6.5L12 5.5C12 4.94 11.55 4.5 11 4.5L5 4.5ZM10.5 6.5C10.77 6.5 11 6.27 11 6C11 5.72 10.77 5.5 10.5 5.5C10.22 5.5 10 5.72 10 6C10 6.27 10.22 6.5 10.5 6.5ZM5 8.5C4.44 8.5 4 8.94 4 9.5L4 10.5C4 11.05 4.44 11.5 5 11.5L11 11.5C11.55 11.5 12 11.05 12 10.5L12 9.5C12 8.94 11.55 8.5 11 8.5L5 8.5ZM10.5 10.5C10.77 10.5 11 10.27 11 10C11 9.72 10.77 9.5 10.5 9.5C10.22 9.5 10 9.72 10 10C10 10.27 10.22 10.5 10.5 10.5Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.bc9378d1bff061a5d42cd7d63cf6426b.svg";
export { ForwardRef as ReactComponent };